import CrudCustom from '../../../libs/custom/CrudCustom';


let PenyusutanPeriodeService = new CrudCustom('/penyusutan-periode-asets');
export default PenyusutanPeriodeService;
